import { BrowseTypesEnum } from '@kinomap-dev/ng-ui-lib';
import { CarouselItems } from '../models/carousel-items.enum';

export const browseTypeToPath = (
  browseType: BrowseTypesEnum | CarouselItems
) => {
  switch (browseType) {
    case BrowseTypesEnum.Video:
    case CarouselItems.Video:
    case CarouselItems.VideoDetail: {
      return '/browse/watch';
    }
    case BrowseTypesEnum.Coaching:
    case CarouselItems.Coaching:
    case CarouselItems.CoachingDetail: {
      return '/browse/coaching';
    }
    case BrowseTypesEnum.GpsTrack:
    case CarouselItems.Gps:
    case CarouselItems.GpsDetail: {
      return '/browse/gps-only';
    }
    case BrowseTypesEnum.Playlist:
    case CarouselItems.Playlist: {
      return '/browse/playlists';
    }
    case BrowseTypesEnum.Workout:
    case CarouselItems.Workout:
    case CarouselItems.WorkoutDetail: {
      return '/browse/workout';
    }
  }
};
